import baseAPI from '@/api';
import { VerifyRolloverByCoinIdRequestDto } from '@/services/dto/withdraw/verify-rollover-by-coin-request.dto';
import { WithdrawVerifyResponseDto } from '@/services/dto/withdraw/withdraw-verify-request.dto';
import { QueryFunctionContext } from '@tanstack/react-query';

export async function verifyRolloverByCoinId({
  queryKey,
}: QueryFunctionContext) {
  const params = queryKey[1] as VerifyRolloverByCoinIdRequestDto;
  const response = await baseAPI.get<WithdrawVerifyResponseDto>(
    `rollover/verify/${params?.coinId}`,
  );

  return response.data;
}
